import AsyncStorage from '@react-native-async-storage/async-storage';

const INSIGHT_STRIP_HIDDEN_KEY = '@budget/insight_strip_hidden';

export async function loadInsightStripHidden(): Promise<boolean> {
  try {
    const raw = await AsyncStorage.getItem(INSIGHT_STRIP_HIDDEN_KEY);
    return raw === 'true';
  } catch {
    return false;
  }
}

export async function saveInsightStripHidden(hidden: boolean): Promise<void> {
  try {
    await AsyncStorage.setItem(INSIGHT_STRIP_HIDDEN_KEY, hidden ? 'true' : 'false');
  } catch {
    // ignore
  }
}
